import camera from '@/mixins/Customizer/SceneSetup/Camera';
import floor from '@/mixins/Customizer/SceneSetup/Floor';
import shaders from '@/mixins/Customizer/SceneSetup/Shaders';
import stitches from '@/mixins/Customizer/SceneSetup/Stitches';
import raytracer from '@/mixins/Customizer/SceneSetup/Raytracer';

export default {
  mixins: [ camera, floor, shaders, stitches, raytracer ]
};
